/* ─── Modulo: Platform Reviews ──────────────────────────────────────────
   Scroll-snap review rail. Arrows scroll by one card; a sliding progress
   thumb reflects how much of the rail is visible and where it sits.
   Page-builder sections roll their own init (no window.moduloLazyInit —
   that helper ships only with the theme app extension).
   ----------------------------------------------------------------------- */
(function () {
  'use strict';
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function stepSize(rail) {
    var card = rail.querySelector('.modulo-tp__card');
    if (!card) return rail.clientWidth * 0.8;
    var gap = parseFloat(getComputedStyle(rail).gap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function updateArrows(rail, prev, next) {
    var max = rail.scrollWidth - rail.clientWidth;
    if (prev) prev.disabled = rail.scrollLeft <= 2;
    if (next) next.disabled = rail.scrollLeft >= max - 2;
  }

  /* Sliding window: thumb width = fraction of the rail in view, and it
     translates left→right as the rail scrolls so each click visibly advances. */
  function updateProgress(rail, thumb) {
    if (!thumb) return;
    var scrollW = rail.scrollWidth;
    var clientW = rail.clientWidth;
    var max = scrollW - clientW;
    var visible = scrollW > 0 ? clientW / scrollW : 1;
    var w = Math.max(0.12, Math.min(1, visible));
    var pct = max > 2 ? rail.scrollLeft / max : 0;
    thumb.style.width = (w * 100) + '%';
    thumb.style.transform = 'translateX(' + (w < 1 ? pct * (1 - w) / w * 100 : 0) + '%)';
  }

  function initSection(section) {
    if (section.__moduloTpInit) return;
    section.__moduloTpInit = true;

    var rail  = section.querySelector('[data-modulo-tp-rail]');
    var prev  = section.querySelector('[data-modulo-tp-prev]');
    var next  = section.querySelector('[data-modulo-tp-next]');
    var thumb = section.querySelector('[data-modulo-tp-thumb]');
    if (!rail) return;

    function sync() {
      updateArrows(rail, prev, next);
      updateProgress(rail, thumb);
    }

    if (prev) prev.addEventListener('click', function () {
      rail.scrollBy({ left: -stepSize(rail), behavior: REDUCE ? 'auto' : 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      rail.scrollBy({ left: stepSize(rail), behavior: REDUCE ? 'auto' : 'smooth' });
    });

    rail.addEventListener('scroll', function () {
      window.requestAnimationFrame(sync);
    }, { passive: true });
    window.addEventListener('resize', sync);

    sync();
  }

  function bootstrap(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var els = scope.querySelectorAll('[data-modulo-tp]');
    for (var i = 0; i < els.length; i++) initSection(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootstrap(); });
  } else {
    bootstrap();
  }

  /* Theme editor: re-init when a section is added or re-rendered. */
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector ? e.target.querySelector('[data-modulo-tp]') : null;
    if (el) initSection(el);
  });
})();
